import React, { useContext, useEffect, useState } from 'react'
import AppointmentsTab from './AppointmentsTab'
import GlobalContext from '../GlobalContext'
import { Spin } from 'antd'

export default function AppointmentsPage () {
  const { appointments, getAppointments } = useContext(GlobalContext)
  const [_, setTime] = useState(Date.now())

  useEffect(() => {
    getAppointments()
    const interval = setInterval(() => setTime(Date.now()), 5000)
    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <Spin spinning={!appointments}>
     { appointments && <AppointmentsTab appointments={appointments} /> }
    </Spin>
  )
}
